import { Chat } from "../interfaces"

export const sortChatsByLastMessage = (chats: Chat[]) => {
    return [...chats].sort((a, b) => {
        if (!a.lastMessage?.timestamp) return 1
        if (!b.lastMessage?.timestamp) return -1

        return (
            new Date(b.lastMessage.timestamp).getTime() -
            new Date(a.lastMessage.timestamp).getTime()
        )
    })
}
